<template>
  <v-row>
    <v-col cols="12">
      <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="article"/>
      <template v-else>
        <v-card>
          <v-toolbar color="transparent" flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
              <router-link :to="{name: 'ProductRetrieveUpdate', params: {id: $route.query.product}}" class="subtitle-1 routerLink font-weight-medium">{{productsDetail.name}}</router-link>
              <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>
              <span class="subtitle-1 font-weight-medium">Nuevo plan de precios</span>
            </v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text class="pa-0 background">
            <v-row class="py-6">
              <v-col md="8">
                <v-list class="v-list-form transparent">
                  <v-list-item class="my-3">
                    <v-list-item-title>
                      Nombre
                      <v-tooltip right max-width="280px" transition="scale-transition">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                        </template>
                        <span>No será visible para los clientes, pero te ayudará a identificar este plan en tu cuenta.</span>
                      </v-tooltip>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-text-field id="it-plan-name" v-model.trim="$v.plan.name.$model" :error="$v.plan.name.$error" background-color="white" outlined required single-line dense  maxlength="35" hint="Nombre es requerido." persistent-hint :hide-details="!$v.plan.name.$error" placeholder="Mensual" />
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>Descripción</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-text-field id="it-plan-description" v-model="$v.plan.description.$model" :error="$v.plan.description.$error" background-color="white" outlined required single-line dense  maxlength="200" hint="Escribe una descripción" persistent-hint :hide-details="!$v.plan.description.$error" placeholder="Ej: Acceso mensual a ..." />
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>Moneda</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col id="it-plan-currency" cols="8">
                        <v-select v-model.trim="$v.plan.currency.$model" :items="currencies" item-value="id" item-text="name" label="Elige una moneda" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details>
                          <template v-slot:item="data">
                            <v-list-item-title>{{data.item.id}} - {{data.item.name}}</v-list-item-title>
                          </template>
                        </v-select>
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>Frecuencia de facturación</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col id="it-plan-frequency" cols="8">
                        <v-select v-model.trim="$v.plan.frequency.$model" :items="frequenciesList" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="mt-6">
                    <v-list-item-title>
                      <span class="text--secondary font-weight-medium">Precio</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>Precio definido por niveles</v-list-item-title>
                    <v-list-item-subtitle absolute>
                      <v-switch class="mt-n4" v-model="hasTiers" style="position: absolute" />
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="my-3" v-if="!hasTiers">
                    <v-list-item-title>Precio unitario</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="5">
                        <v-text-field id="it-plan-amount" v-model.number="$v.plan.amount.$model" :error="$v.plan.amount.$error" :suffix="plan.currency" hint="Escribe un precio" persistent-hint :hide-details="!$v.plan.amount.$error" background-color="white" outlined required single-line dense placeholder="0.00" />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="d-block" v-if="hasTiers">
                    <v-row>
                      <v-col cols="12" class="d-flex py-1" v-for="(f, i) in plan.tiers" :key="i">
                        <div style="width:140px">
                          <v-text-field class="ma-1 ml-0" v-model.number="plan.tiers[i].amount" :suffix="plan.currency" placeholder="0.00" :hint="`El precio del nivel ${i+1} es requerido`" persistent-hint :hide-details="!$v.plan.tiers.$each[i].amount.$error" :error="$v.plan.tiers.$each[i].amount.$error" background-color="white" outlined required single-line dense  />
                        </div>
                        <div style="width:260px">
                          <v-select class="ma-1" v-model.trim="$v.plan.tiers_mode.$model" :items="planDetail" :disabled="i > 0" item-value="value" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details />
                        </div>
                        <div class="text--secondary mx-2 py-3 background" style="width:130px">
                          la cantidad es de
                        </div>
                        <div style="width:160px" v-if="i === plan.tiers.length - 1">
                          <v-text-field class="pa-0" :prefix="`${plan.tiers[i].quantity_from} o más`" hide-details background-color="white" outlined single-line dense disabled readonly />
                        </div>
                        <div style="width:160px" v-else>
                          <v-text-field class="pa-0" v-model.number="plan.tiers[i].quantity_to" :prefix="`${plan.tiers[i].quantity_from} a`" :hint="`El máximo del nivel ${i + 1} es requerido`" persistent-hint :hide-details="!$v.plan.tiers.$each[i].quantity_to.$error" :error="$v.plan.tiers.$each[i].quantity_to.$error" background-color="white" outlined required single-line dense :keyup="setNextTier(i)" />
                        </div>
                        <div class="mx-2" style="width:40px">
                          <v-btn v-if="i >= 2 && i==plan.tiers.length-1" @click="removeRowTiers(i)" icon color="red"><v-icon small>mdi-close</v-icon></v-btn>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="ml-3">
                        <v-btn @click.prevent="addRowTiers" text color="primary" :ripple="false"><v-icon left>mdi-plus</v-icon>Agregar nuevo nivel</v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>Plan exento de impuestos</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-switch class="mt-n4" v-model="plan.exempt" style="position: absolute"/>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="mt-6">
                    <v-list-item-title>
                      <span class="text--secondary font-weight-medium">Consumo</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>
                      El consumo es según el uso
                      <v-tooltip right max-width="280px" transition="scale-transition">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                        </template>
                        <span>La facturación por uso te permite cobrar de acuerdo al o los registros de uso que se hayan informado al final de cada periodo de facturación.</span>
                      </v-tooltip>
                    </v-list-item-title>
                    <v-list-item-subtitle absolute>
                      <v-switch class="mt-n4" v-model="plan.usage_scheme" false-value="licensed" true-value="metered" style="position: absolute" />
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="my-3" v-if="plan.usage_scheme === 'metered'">
                    <v-list-item-title>Cobrar uso según</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-radio-group v-model="plan.usage_aggregation" :mandatory="false">
                        <v-radio v-for="aggregation in usageAggregationsList" :key="aggregation.value" :label="aggregation.label" :value="aggregation.value"></v-radio>
                      </v-radio-group>
                    </v-list-item-subtitle>
                  </v-list-item>

                  <!-- more options -->
                  <v-list-item class="mt-6">
                    <v-list-item-title>
                      <span class="text--secondary font-weight-medium">Otras opciones</span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>Código</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="5">
                        <v-text-field id="it-plan-sku" v-model.trim="$v.plan.sku.$model" :error="$v.plan.sku.$error" background-color="white" outlined required single-line dense maxlength="32" persistent-hint hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="my-3">
                    <v-list-item-title>Unidad</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="5">
                        <v-text-field id="it-plan-unit_label" v-model.trim="$v.plan.unit_label.$model" :error="$v.plan.unit_label.$error" background-color="white" placeholder="Etiqueta de unidad" outlined required single-line dense maxlength="4" persistent-hint hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <!-- end more options -->
                </v-list>
              </v-col>
            </v-row>
            <v-divider />
            <v-row class="px-3">
              <v-col cols="12" class="white">
                <span class="body-1 text--secondary font-weight-medium">Previsualización</span>
              </v-col>
              <v-col cols="12" class="d-flex align-center white">
                <span class="mr-3">Un cliente suscrito a</span>
                <v-text-field id="it-plan-preview" v-model.number="previewQuantity" style="max-width:100px" background-color="white" outlined required single-line dense persistent-hint hide-details />
                <span class="ml-3">{{productsDetail.unit_label}}(s) deberá pagar</span>
                <span class="ml-1 font-weight-medium">{{preview | currency(activeCurrency.id)}} {{activeCurrency.id}}</span>
                <span class="ml-1" v-if="!plan.exempt">+ impuestos</span>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-4">
            <v-spacer/>
            <v-btn id="it-plan-create" @click="createPlan" :loading="$store.state.subscriptions.createLoader" color="primary">Crear plan</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, maxLength, requiredIf, numeric, decimal } from 'vuelidate/lib/validators'
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  mixins: [
    GenericViewMixin
  ],
  data () {
    return {
      plan: {
        amount: null,
        currency: 'CLP',
        description: '',
        exempt: false,
        frequency: 'monthly',
        name: '',
        product: this.$route.query.product,
        sku: null,
        tiers: [],
        tiers_mode: null,
        usage_scheme: 'licensed',
        usage_aggregation: 'sum',
        unit_label: null
      },
      hasTiers: false,
      previewQuantity: 1,
      test: [],
      planDetail: [
        { name: '', value: 'unit' },
        { name: '', value: 'range' }
      ],
      usageAggregationsList: [
        { value: 'sum', label: 'Suma de los registros de uso informados en el periodo' },
        { value: 'max', label: 'Máximo registro de uso informado en el periodo' },
        { value: 'last_record', label: 'Último registro de uso informado en el período' }
      ]
    }
  },
  computed: {
    preview () {
      if (this.hasTiers) {
        if (this.plan.tiers.filter(t => !t.quantity_to).length > 1) {
          return 0
        }
        let tier = this.plan.tiers.find(t => t.quantity_to && t.quantity_from <= this.previewQuantity && t.quantity_to >= this.previewQuantity)
        if (!tier) {
          tier = this.plan.tiers.find((t, i) => i === this.plan.tiers.length - 1)
        }
        return this.plan.tiers_mode === 'unit' ? tier.amount * this.previewQuantity : tier.amount
      }
      return this.plan.amount * this.previewQuantity
    },
    activeCurrency () {
      return this.currencies.find(c => c.id === this.plan.currency)
    },
    ...mapState({
      productsDetail: state => state.subscriptions.productsDetail,
      frequenciesList: state => state.subscriptions.frequenciesList
    })
  },
  created () {
    this.$store.dispatch('subscriptions/RETRIEVE', {
      resource: 'products',
      id: this.$route.query.product
    })
    .then(() => {
      if (!this.$store.state.subscriptions.frequenciesList.length) {
        this.$store.dispatch('subscriptions/LIST', {
          resource: 'frequencies'
        })
      }
    })
  },
  watch: {
    hasTiers () {
      if (this.hasTiers) {
        this.plan.tiers_mode = 'unit'
        this.plan.tiers = [
          {
            amount: null,
            quantity_to: null,
            quantity_from: 0
          },
          {
            amount: null,
            quantity_to: null,
            quantity_from: null
          }
        ]
      } else {
        this.plan.tiers_mode = null
        this.plan.tiers = []
      }
      this.planDetail[0].name = 'por cada ' + `${this.productsDetail.unit_label}` + ' si'
      this.planDetail[1].name = 'por todos los ' + `${this.productsDetail.unit_label}s` + ' si'
    }
  },
  methods: {
    createPlan () {
      if (this.hasTiers) {
        this.plan.amount = this.plan.tiers[0].amount
        this.plan.tiers[this.plan.tiers.length - 1].quantity_to = 0
      }
      this.$v.plan.$touch()
      if (this.$v.plan.$invalid) {
        return false
      }
      this.$store.dispatch('subscriptions/CREATE', {
        resource: 'plans',
        payload: this.plan
      })
      .then((response) => {
        this.$router.push({
          name: 'PlanRetrieveUpdate',
          params: {
            id: response.data.id
          }
        })
        this.$dialog.message.info('El plan ha sido creado')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    addRowTiers () {
      this.plan.tiers[this.plan.tiers.length - 1].quantity_to = null
      this.plan.tiers.push({
        amount: null,
        quantity_to: null,
        quantity_from: null
      })
    },
    setNextTier (i) {
      this.plan.tiers[i + 1].quantity_from = this.plan.tiers[i].quantity_to + 1
    },
    removeRowTiers (i) {
      this.plan.tiers.splice(i, 1)
    }
  },
  validations: {
    plan: {
      amount: {
        required: requiredIf(function () {
          return !this.hasTiers
        }),
        decimal
      },
      sku: {
        maxLength: maxLength(32)
      },
      currency: {
        required
      },
      description: {
        required,
        maxLength: maxLength(200)
      },
      frequency: {
        required
      },
      name: {
        required,
        maxLength: maxLength(56)
      },
      tiers: {
        $each: {
          amount: {
            required: requiredIf(function () {
              return this.hasTiers
            }),
            decimal
          },
          quantity_from: {
            required: requiredIf(function () {
              return this.hasTiers
            }),
            numeric
          },
          quantity_to: {
            required: requiredIf(function () {
              return this.hasTiers
            }),
            numeric
          }
        }
      },
      tiers_mode: {
        required: requiredIf(function () {
          return this.hasTiers
        })
      },
      unit_label: {
        maxLength: maxLength(4)
      }
    }
  }
}
</script>